import React, { useEffect, useState } from "react";
import "./mylisting.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import dlt from "../../myimgs/trash.png";
import placeimg from "../../myimgs/Group 193.png";
import Swal from "sweetalert2";
import Noprop from "../../myimgs/NestingIndia.png";


const MyListings = () => {
  const [listings, setListings] = useState([]);
  const [isApproved, setIsApproved] = useState(false);
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  useEffect(() => {
    const fetchListings = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
         
        const response = await fetch(`${baseUrl}/property/list`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            page: 0,
            size: 500,
            userId: userId,
            isApproved: isApproved,
          }),
        });

        const data = await response.json();

        if (data?.data?.content) {
          setListings(data.data.content);
        } else {
          setListings([]);
        }
      } catch (error) {
         console.log(error);
        console.error("Error fetching listings:", error);
      }
    };

    fetchListings();
  }, [isApproved]); // Re-fetch when tab changes

  const handleViewDetails = (id) => {
    localStorage.setItem("selectedPropertyId", id);
    navigate("/mylistingview");
  };
  const handleViewDetail = (item) => {
    localStorage.setItem("selectedPropertyId", item.id);
    localStorage.setItem("sell", item.sell); // save actual sell value (true/false)
    navigate("/purchagdetails");
  };
 const handleEdit = (id, propeId) => {
  const url = `/editProperty?id=${encodeURIComponent(id)}&propeId=${encodeURIComponent(propeId)}`;
  window.open(url, "_blank");
};

   // Delete API function
    const handleDelete = async (propertyId) => {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
  
      // Show confirmation alert before deleting
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to delete this property?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });
  
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${baseUrl}/property/remove/${propertyId}`, {
            method: "get",
          });
  
          const data = await response.json();
  
          if (response.ok) {
            Swal.fire("Deleted!", "Your property has been deleted.", "success");
  
            // Remove the deleted property from UI
            setListings((prev) => prev.filter((item) => item.id !== propertyId));
          } else {
            Swal.fire("Error!", data.message || "Failed to delete property.", "error");
          }
        } catch (error) {
          console.error("Delete error:", error);
          Swal.fire("Error!", "Something went wrong while deleting.", "error");
        }
      }
    };

  return (
    <div className="mylistings">
      <h2 className="section-title">My Listings</h2>

      {/* Status Tabs */}
      <div className="status-tabs">
        <button
          className={`status-btn ${!isApproved ? "active" : ""}`}
          onClick={() => setIsApproved(false)}
        >
          Pending
        </button>
        <button
          className={`status-btn ${isApproved ? "active" : ""}`}
          onClick={() => setIsApproved(true)}
        >
          Approved
        </button>
      </div>

      {/* Listing Cards */}
       <div className="listings">
          {listings.length > 0 ? (
            listings.map((item) => (
              <div key={item.id} className="listing-card">
                <img
                  src={
                    item.propertyImages?.length > 0
                      ? item.propertyImages[0].imageUrl
                      : placeimg
                  }
                  alt={item.streetAddress}
                  className="listing-img"
                />
                <div className="listing-info">
                  <h3 className="listing-title">{item.streetName}</h3>
                  <div className="auction-details">
                {(item.listingId || item.propeId) && (
                  <h3 className="mls">
                    {item.listingId ? (
                      <>
                        <strong>MLS No:</strong> {item.listingId}
                      </>
                    ) : (
                      <>
                        <strong>Property Id:</strong> {item.propeId}
                      </>
                    )}
                  </h3>
                )}
                <p className="listed-by">
                  Listed by <span>{item.user?.name}</span>
                </p>

                {/* Address */}
                <h3 className="address">{item.unparsedAddress}</h3>

                <div className="property-specs">
                  {item.bedroomsTotal > 0 && (
                    <span className="spec">🛏{item.bedroomsTotal}bed</span>
                  )}

                  {item.bathroomsTotalInteger > 0 && (
                    <span className="spec">
                      🛁{item.bathroomsTotalInteger}bath
                    </span>
                  )}

                  {item.lotSizeArea > 0 && (
                    <span className="spec">📐{item.lotSizeArea}ft</span>
                  )}
                </div>
              </div>
                  <div className="actions">
                    <div className="action-buttons">
                      <button
                        className="btn purchase-btn"
                        onClick={() => handleViewDetails(item.id)}
                      >
                        View Details
                      </button>
                      {!isApproved && (
                        <button
                          className="btn purchase-btn edit-btn"
                        onClick={() => {
                            handleEdit(item.id, item.propeId);
                          }}
                          >
                          Edit
                        </button>
                      )}

                      {isApproved && (
                        <button
                          className="btn purchase-btn"
                          onClick={() => handleViewDetail(item)}
                        >
                          Purchase Details
                        </button>
                      )}

                      <button
                        className="btndf"
                        onClick={() => handleDelete(item.id)}
                      >
                        <img src={dlt} alt="" /> Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
             <p style={{ textAlign: "center" }}>
                  <img src={Noprop} />
                </p>
          )}
        </div>
    </div>
  );
};

export default MyListings;
